import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';

export default (function (param) {
  const { data, exec, isRequestSuccessed } = useRequest({
    name: 'GET_BLOCKED_REASON',
    url: '',
    manual: false,
  });

  const fetchData = function () {
    let url = '/api/blocked_reason';
    if (param) {
      Object.keys(param).forEach((key, index) => {
        if (index === 0) {
          url += '?';
        } else {
          url += '&';
        }
        url += `${key}=${param[key]}`;
      });
    }
    exec(url);
  };
  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [param]);

  return [data || [], fetchData, isRequestSuccessed];
});
